import React from 'react';
import { exportWarningFor, resolveImageLink } from '../utils/imageLink';
import MediaLinkInput from './MediaLinkInput';

/**
 * "Use a link instead of a copy" for a picture.
 *
 * Sits beside every upload control that would otherwise turn a file into a
 * base64 data URL inside the deck. What comes back is an address, so the deck
 * JSON and its exports stay small however large the picture is.
 *
 * A page link (a Pinterest pin, a Flickr photo) is resolved to the picture the
 * site publishes for it; a link straight to a file is used as pasted. Either
 * way the caller receives a plain URL and stores it exactly where it stored the
 * data URL before.
 *
 * The field, the button and the status line live in MediaLinkInput, which the
 * audio link control shares. Everything image-specific — the lookup, and what
 * to say about the result — is here.
 */
const describeSuccess = (result) => (result.inlined
  // Worth saying plainly: this one case does put the picture in the deck.
  ? `Added from ${result.provider || 'that page'} — it publishes only an inlined preview, so this one is stored in the deck rather than linked.`
  : `Linked${result.provider ? ` from ${result.provider}` : ''}. The deck stores the address, not the file.`);

const ImageLinkInput = ({
  onUseLink,
  label = 'Or paste a link',
  description = 'Cloudflare R2, an LMS folder, any CDN — or a Pinterest, Flickr, Instagram, Imgur or GIPHY page. The picture stays where it is hosted, so the deck stays small.',
  placeholder = 'https://…/photo.png',
  buttonLabel = 'Use link',
  tone = 'light',
  disabled = false
}) => (
  <MediaLinkInput
    resolve={resolveImageLink}
    onResolved={(result) => onUseLink?.(result.url, result)}
    describeSuccess={describeSuccess}
    describeWarning={exportWarningFor}
    label={label}
    description={description}
    placeholder={placeholder}
    buttonLabel={buttonLabel}
    tone={tone}
    disabled={disabled}
  />
);

export default ImageLinkInput;
